import React from 'react';
import { Button } from './ui/button';
import { MessageCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { content, whatsappNumber } from '../mock';

export const WhatsAppWidget = () => {
  const { language } = useLanguage();
  const t = content[language];

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(t.whatsappText);
    const whatsappUrl = `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <Button
      onClick={handleWhatsAppClick}
      className="w-full bg-green-600 hover:bg-green-700 text-white shadow-lg transition-all hover:shadow-xl"
      size="lg"
    >
      <MessageCircle className="h-5 w-5 mr-2" />
      {t.whatsappButton}
    </Button>
  );
};
